
import React from 'react'

import Resources from './Resources'
import Endpoints from './Endpoints'

import style from './List.module.scss'

const List = ({
  list
}) => (
  <div className={ style.block }>
    <header><span>{ list.name }</span></header>

    <div className={style.content}>
      <Resources resources={list.resources} />
      <Endpoints endpoints={list.endpoints} />
    </div> 
  </div>
)

export default List